(function () {

  function run() {
    const nodes = document.querySelectorAll('.est-delivery__date');
    if (!nodes.length) return;

    const banner = document.querySelector('.homepage-banner[data-offset-days]');
    const offsetDays = banner ? parseInt(banner.dataset.offsetDays, 10) : 1;

    const date = new Date();
    date.setDate(date.getDate() + offsetDays);

    const formattedDate = date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });

    const regex = /\|date\|/g;

    for (let i = 0; i < nodes.length; i++) {
      const el = nodes[i];

      if (el.innerHTML.indexOf('|date|') !== -1) {
        el.innerHTML = el.innerHTML.replace(regex, formattedDate);
      }
    }
  }

  function setupRotator(rotator) {
    const slides = Array.from(rotator.querySelectorAll('.homepage-banner-rotator__slide'));
    if (slides.length < 2) return;

    const dots = Array.from(rotator.querySelectorAll('.homepage-banner-rotator__dot'));
    const prevButton = rotator.querySelector('.homepage-banner-rotator__arrow--prev');
    const nextButton = rotator.querySelector('.homepage-banner-rotator__arrow--next');
    const interval = (parseFloat(rotator.dataset.rotateInterval) || 7) * 1000;

    let index = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (index < 0) index = 0;

    function restartAutoplay() {
      clearInterval(rotator.rotatorTimer);
      rotator.rotatorTimer = setInterval(function () {
        goTo(index + 1);
      }, interval);
    }

    function goTo(targetIndex) {
      targetIndex = ((targetIndex % slides.length) + slides.length) % slides.length;
      if (targetIndex === index) return;

      const current = slides[index];
      const next = slides[targetIndex];

      requestAnimationFrame(function () {
        current.classList.remove('is-active');
        next.classList.add('is-active');
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === targetIndex);
        dot.setAttribute('aria-selected', i === targetIndex ? 'true' : 'false');
      });

      index = targetIndex;
      restartAutoplay();
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        goTo(index - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
      });
    });

    let touchStartX = null;
    let touchStartY = null;

    rotator.addEventListener(
      'touchstart',
      function (event) {
        const touch = event.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      },
      { passive: true }
    );

    rotator.addEventListener(
      'touchend',
      function (event) {
        if (touchStartX === null) return;

        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;

        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

        goTo(deltaX < 0 ? index + 1 : index - 1);
      },
      { passive: true }
    );

    restartAutoplay();
    rotator.rotatorInitialized = true;
  }

  function initRotators(sectionId) {
    document.querySelectorAll('.homepage-banner-rotator--active').forEach(function (rotator) {
      if (sectionId && rotator.dataset.sectionId !== sectionId) return;
      if (rotator.rotatorInitialized) return;

      setupRotator(rotator);
    });
  }

  function destroyRotators(sectionId) {
    document.querySelectorAll('.homepage-banner-rotator').forEach(function (rotator) {
      if (sectionId && rotator.dataset.sectionId !== sectionId) return;
      if (rotator.rotatorTimer) {
        clearInterval(rotator.rotatorTimer);
        rotator.rotatorTimer = null;
      }
      rotator.rotatorInitialized = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('DOMContentLoaded', function () {
      initRotators();
    });
  } else {
    run();
    initRotators();
  }

  document.addEventListener('shopify:section:unload', function (event) {
    destroyRotators(event.detail && event.detail.sectionId);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initRotators(event.detail && event.detail.sectionId);
  });

})();
